var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('T1Breadcrumbs',{staticClass:"mb-24",attrs:{"homeLink":true,"items":_vm.getBreadcrumbs()}}),_c('h1',{staticClass:"font-24 mb-24"},[_vm._v("\n    Porównanie ofert\n  ")]),_c('T1SchowekCompareOffers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }